import * as ActionTypes from 'state/types'


export default (state = {
  isRequesting: false,
  isFailing: false,
  collection: [],
  page: 0,
  pages: 0,
  scrollToBottomRequired: false,
  isChatEnabled: false
}, action) => {
  switch (action.type) {

    case ActionTypes.SELECT_INTERACTION:
      return {
        ...state,
        isRequesting: false,
        isFailing: false,
        collection: [],
        page: 0,
        pages: 0
      }

    case `${ActionTypes.ACTIVITIES_REQUEST}_START`:
      return {
        ...state,
        isRequesting: true,
        isChatEnabled: false
      }

    case `${ActionTypes.ACTIVITIES_REQUEST}_SUCCESS`: {

      const {
        collection,
        page,
        pages
      } = action.response.payload

      const updatedCollection = (page > state.page) ? [
        ...collection.reverse(),
        ...state.collection
      ] : state.collection

      return {
        ...state,
        isRequesting: false,
        collection: updatedCollection,
        page: page,
        pages: pages,
        isChatEnabled: true
      }

    }

    case `${ActionTypes.ACTIVITIES_REQUEST}_FAIL`:
      return {
        ...state,
        isRequesting: false,
        isFailing: true

      }

    case ActionTypes.RECEIVE_ACTIVITY: {
      const updatedActivities = [
        ...state.collection,
        action.activity
      ].filter((e) => !e.tempId || e.failed)
      return {
        ...state,
        collection: updatedActivities,
        scrollToBottomRequired: true
      }
    }

    case ActionTypes.ADD_MESSAGE: {
      const updatedActivities = [
        ...state.collection,
        action.payload
      ]
      return {
        ...state,
        collection: updatedActivities,
        scrollToBottomRequired: true
      }
    }

    case ActionTypes.SCROLL_TO_TOP: {
      return {
        ...state,
        scrollToTopRequired: true
      }
    }

    case ActionTypes.SCROLL_TO_BOTTOM: {
      return {
        ...state,
        scrollToBottomRequired: true
      }
    }

    case ActionTypes.FINISH_SCROLL_TO_TOP: {
      return {
        ...state,
        scrollToTopRequired: false
      }
    }

    case ActionTypes.FINISH_SCROLL_TO_BOTTOM: {
      return {
        ...state,
        scrollToBottomRequired: false
      }
    }


    case ActionTypes.UPDATE_ACTIVITY: {
      const updatedActivities = state.collection.filter((e) => e.tempId !== action.payload.tempId)

      return {
        ...state,
        scrollToBottomRequired: true,
        collection: [...updatedActivities, action.payload]
      }
    }

    case ActionTypes.ACTIVITIES_BOTTOM_REACHED: {
      return {
        ...state,
        scrollToBottomRequired: false
      }
    }


    default:
      return state
  }
}
